// See reasoning for those default values in https://confluence.astrazeneca.com/display/AZU/Withdraw+Consent+for+10.0

export const DEFAULT_SCHEDULE_META_PROPERTY_DATA_PROCESSING = false;

export const DEFAULT_SCHEDULE_META_PROPERTY_ENABLE_RECONSENT = true;

export type ConsentDataWithdrawOptions =
  | Record<string, string>
  | {
      SoftDeleteHistory: 'true' | 'false';
    };

export const CONSENT_DATA_OPTIONS_CONTINUE_USING: ConsentDataWithdrawOptions = {
  SoftDeleteHistory: 'false',
};

export const CONSENT_DATA_OPTIONS_STOP_USING: ConsentDataWithdrawOptions = {
  SoftDeleteHistory: 'true',
};

export const CONSENT_DATA_OPTIONS_NO_DECISION: ConsentDataWithdrawOptions = {};
